import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface AssignReviserResponse {
  task: {
    assignReviser: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class AssignReviserService {
  constructor(private apollo: Apollo) {}

  assignReviser(
    taskId,
    newReviserId,
    mutation: DocumentNode
  ): Observable<FetchResult<AssignReviserResponse>> {
    return this.apollo.mutate<AssignReviserResponse>({
      mutation: mutation,
      variables: {
        taskId,
        newReviserId,
      },
    });
  }
}
